import React, { FC, useCallback, useEffect, useState } from 'react'
import classes from './MultiInputHeader.module.scss'
import { useGetWorkerInfo } from '../../../hooks/api/workers/useGetWorkerInfo'
import { Switch, TextField, useTheme } from '@mui/material'
import SingleDatePicker from '../../uikit/atoms/datepickers/SingleDatePicker'
//キャンセル
import CancelIcon from '@mui/icons-material/Cancel'
import {
  compareTimeTable,
  getTimesDownTo,
  getTimesUpTo,
  timeList,
} from '../../../utils/variables/timeList'
import SelectBoxForString from '../../uikit/atoms/selectboxes/SelectBoxForString'
import {
  calcTotalTimeByDiary,
  calcTotalTimeByFromAndTo,
} from '../../../utils/functions/calcTotalTime'
import { useRecoilState } from 'recoil'
import { userState } from '../../../states/userState'
import { User, Worker } from '../../../types'
import { Dirary } from '../../../types/dirary'
import { setUserToLocalStorage } from '../../../utils/functions/localStorageManager'
import { formatDate } from '../../../utils/functions/formatting'
import { useGetDiaryList } from '../../../hooks/api/posts/useGetDiraryList'
import { Buttons } from '../../uikit/atoms/buttons/Buttons'
import SelectBoxForNumber from '../../uikit/atoms/selectboxes/SelectBoxForNumber'
import { breakTimeList } from '../../../utils/variables/breakTime'

type Props = {
  setTotalTime: React.Dispatch<
    React.SetStateAction<{ hour: number; min: number; text: string }>
  >
  totalTime: { hour: number; min: number; text: string }

  workingDate: {
    obj: Date
    text: string
  }
  setWorkingDate: React.Dispatch<
    React.SetStateAction<{
      obj: Date
      text: string
    }>
  >
  hasBreak: boolean
  setHasBreak: React.Dispatch<React.SetStateAction<boolean>>
  fromTime: string
  toTime: string
  setFromTime: React.Dispatch<React.SetStateAction<string>>
  setToTime: React.Dispatch<React.SetStateAction<string>>
  setFetchDiaryList: React.Dispatch<React.SetStateAction<Dirary[]>>
  diaryList: Dirary[]
  setDiaryList: React.Dispatch<React.SetStateAction<Dirary[]>>
  breakTime: number
  setBreakTime: React.Dispatch<React.SetStateAction<number>>
}

const MultiInputHeader: FC<Props> = (props) => {
  const {
    totalTime,
    setTotalTime,
    workingDate,
    setWorkingDate,
    hasBreak,
    setHasBreak,
    fromTime,
    toTime,
    setFromTime,
    setToTime,
    setFetchDiaryList,
    diaryList,
    setDiaryList,
    breakTime,
    setBreakTime,
  } = props
  const [user, setUser] = useRecoilState<User>(userState)
  const theme = useTheme()
  const getWorkerInfo = useGetWorkerInfo()
  const { getDiaryListByWokerAndDay } = useGetDiaryList()
  //社員マスタ情報-4
  // const [workerInfo, setWorkerInfo] = useState({
  //   workerId: "",
  //   workerName: "",
  //   departmentId: null,
  //   departmentName: null,
  //   place: null,
  // });

  //エラーメッセージ-2
  const [errorWorkerName, setErrorWorkerName] = useState({
    isShow: true,
    text: '',
  })

  const [fromTimeList, setFromTimeList] =
    useState<{ id: string; name: string }[]>(timeList)
  const [toTimeList, setToTimeList] =
    useState<{ id: string; name: string }[]>(timeList)

  // const [toTimeList, setToTimeList] = useState<{ id: string; name: string }[]>(
  //   getTimesDownTo(timeList, fromTime)
  // );

  //作業開始日が変更されたとき
  const handleWorkingDateChange = (newDate: any) => {
    setWorkingDate({ obj: newDate, text: formatDate(newDate) })
  }
  //開始時刻が変更されたとき
  const handleFromTimeChange = (e: string) => {
    setFromTime(() => {
      // setToTimeList(getTimesDownTo(timeList, e));
      return e
    })
  }
  useEffect(() => {
    //終了時刻強制セット
    // if (compareTimeTable(fromTime, toTime)) setToTime(toTimeList[0].id);
  }, [toTimeList])
  //時刻計算
  useEffect(() => {
    // const { hour, min, text } = calcTotalTimeByFromAndTo(
    //   fromTime,
    //   toTime,
    //   hasBreak
    // );
    const { hour, min, text, endTime } = calcTotalTimeByDiary(
      fromTime,
      diaryList,
      hasBreak,
      breakTime
    )
    setTotalTime({ hour, min, text })
    setToTime(endTime)
    setDiaryList((prevList) => {
      return prevList.map((diary: Dirary) => {
        // if (diary.workingDate === workingDate.text) {
        return {
          ...diary,
          startTime: fromTime,
          endTime: endTime,
          isBreak: hasBreak,
          breakTime: breakTime,
          totalWorkingTimeByHour: hour,
          totalWorkingTimeByMinute: min,
        }
        // } else {
        //   return diary;
        // }
      })
    })
  }, [fromTime, toTime, breakTime])

  const checkFromTimeDisabled = useCallback(() => {
    if (diaryList.length > 0 && diaryList[0].isDisabled) {
      return true
    } else {
      return false
    }
  }, [diaryList])

  const handleBreakTimeChange = (e: number) => {
    setBreakTime(e)
    setHasBreak(e > 0)
  }

  return (
    <div className={classes.rootContainer}>
      <div className={classes.workerArea}>
        <div className={`${classes.date}`}>
          <SingleDatePicker
            disabled={false}
            currentDate={workingDate.obj}
            label={'作業日'}
            onChange={handleWorkingDateChange}
          />
        </div>
        <div className={classes.time}>
          <SelectBoxForString
            label={'開始時刻'}
            options={fromTimeList}
            required={true}
            select={handleFromTimeChange}
            value={fromTime}
            disabled={checkFromTimeDisabled()}
            width={'75px'}
            height={'32px'}
            fontSize={'16px'}
            setMode={'input'}
            colorMode={'light'}
          />
        </div>
      </div>
      <div className={classes.dateTimeArea}>
        <div className={classes.firstArea}>
          {/* <div className={classes.date}>
            <SingleDatePicker
              disabled={false}
              currentDate={workingDate}
              label={"作業日"}
              onChange={handleWorkingDateChange}
            />
          </div> */}

          {/* <span className={classes.hyphen}>-</span>
          <div className={classes.time}>
            <SelectBoxForString
              label={"終了時刻"}
              options={toTimeList}
              required={true}
              select={setToTime}
              value={toTime}
              disabled={true}
              width={"85px"}
              height={"32px"}
              fontSize={"16px"}
              setMode={"input"}
              colorMode={"light"}
            />
          </div> */}
          <div className={classes.breakTime}>
            <p
              style={{
                color: hasBreak ? theme.palette.foreColor.main : '#8d94a2',
              }}
            >
              休憩時間
            </p>
            {/* <Switch
              checked={hasBreak}
              onChange={() => setHasBreak(!hasBreak)}
              sx={{
                ...(!hasBreak
                  ? { color: "#4a4f58" }
                  : { color: theme.palette.foreColor.main }),
              }}
            /> */}
            <SelectBoxForNumber
              label={''}
              options={breakTimeList}
              required={true}
              select={handleBreakTimeChange}
              value={breakTime}
              disabled={false}
              width={'60px'}
              height={'32px'}
              fontSize={'16px'}
              colorMode={'light'}
              setMode={'input'}
            />
          </div>
          <div className={classes.totalTime}>
            <p>終了時刻</p>
            <div
              style={{
                color:
                  totalTime.hour <= 0
                    ? theme.palette.error.main
                    : theme.palette.foreColor.main,
              }}
            >
              <>{`${toTime.split(':')[0]}時${toTime.split(':')[1]}分`}</>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.hr} />
    </div>
  )
}

export default MultiInputHeader
